export const MA_ORDER_HISTORY_LOADER = {
  desktop: `
<div class="cui-grid cui-container -spacing--top-64 -spacing--bottom-80" style="max-width: 1110px;">
  <div class="cui-skeleton-heading -size--large -spacing--bottom-40 -resolution--desktop">
    <div class="cui-skeleton__item cui-skeleton-input__label -spacing--bottom-16" style="width: 120px;">
    </div>
    <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
        <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
  </div>
  <div class="cui cui-grid cui-container -gap--v-32 -spacing--bottom-32">
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block -spacing--bottom-8" style="display: flex;">
          <div class="cui-skeleton__item" style="height: 120px; margin-right: 20px;"></div>
          <div class="cui-skeleton__item" style="height: 120px; margin-right: 20px;"></div>
          <div class="cui-skeleton__item" style="height: 120px;"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-6">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="height: 48px; width: min(540px, 100%)"></div>
        </div>
      </div>
      <div class="cui-col-lg-3 col-offset-lg-3">
        <div class="cui-skeleton-rectangle" style="display: flex; justify-content: end; align-items: center; height: 100%;">    
          <div class="cui-skeleton__item" style="height: 24px; width: min(200px, 100%)"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-6">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="height: 48px; width: min(540px, 100%)"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="cui cui-grid cui-container">
    <div class="cui-skeleton-heading -size--large -spacing--bottom-24 -resolution--desktop">
      <div class="cui-skeleton__item cui-skeleton-input__label" style="width: 120px;"></div>
    </div>
  </div>
  <div class="cui cui-grid cui-container -gap--v-4">
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="height: 52px;"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="height: 52px;"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="height: 52px;"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="height: 52px;"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="height: 52px;"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="height: 52px;"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="cui-skeleton-rectangle -is--block">
  <div class="cui-skeleton__item" style="width: 100%; height: 128px;"></div>
</div>`,
  mobile: `
<div class="cui-grid cui-container -spacing--top-24 -spacing--bottom-64">
  <div class="cui-skeleton-heading -size--large -spacing--bottom-24 -resolution--mobile">
    <div class="cui-skeleton__item cui-skeleton-input__label -spacing--bottom-16" style="width: 120px;"></div>
    <div class="cui-skeleton-heading__content" style="width: max(200px, 100%);">
      <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
  </div>
  <div class="cui cui-grid cui-container -spacing--bottom-32">
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="height: 48px; width: max(345px, 100%)"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="cui cui-grid cui-container -gap--v-24 -spacing--bottom-32">
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="height: 24px; width: 80px"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block" style="display: contents;">
          <div class="cui-skeleton__item" style="height: 72px;"></div>
          <div class="cui-skeleton__item" style="height: 72px;"></div>
          <div class="cui-skeleton__item" style="height: 72px;"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="height: 24px; width: 200px"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="height: 40px; width: max(345px, 100%)"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="cui cui-grid cui-container -gap--v-24 -spacing--bottom-32">
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="height: 16px; width: 120px"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block" style="display: contents;">
          <div class="cui-skeleton__item" style="height: 160px; max(345px, 100%);"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block" style="display: contents;">
          <div class="cui-skeleton__item" style="height: 160px; max(345px, 100%);"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block" style="display: contents;">
          <div class="cui-skeleton__item" style="height: 160px; max(345px, 100%);"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block" style="display: contents;">
          <div class="cui-skeleton__item" style="height: 160px; max(345px, 100%);"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block" style="display: contents;">
          <div class="cui-skeleton__item" style="height: 160px; max(345px, 100%);"></div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-rectangle -is--block" style="display: contents;">
          <div class="cui-skeleton__item" style="height: 160px; max(345px, 100%);"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="cui-skeleton-rectangle -is--block">
  <div class="cui-skeleton__item" style="width: 100%; height: 196px;"></div>
</div>`
};
